import React from 'react';

const DetailInfoElement = ({ infos }) => {
  const arrDefault = [
    '_id',
    'nama_produk',
    'jenis_produk',
    'dimensi',
    'bahan',
    'fitur',
    'daya',
    'img',
    'imgPublicID',
    '__v',
    'createdAt',
    'updatedAt',
    '',
  ];

  const dataKeys = Object.keys(infos);
  const nonIntersectingKeys = dataKeys.filter(
    (key) => !arrDefault.includes(key)
  );

  const filteredData = nonIntersectingKeys.reduce((acc, key) => {
    acc[key] = infos[key];
    return acc;
  }, {});

  const capitalizeWords = (str) => {
    return str.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
  };

  return (
    <div>
      <ul className="alignMe">
        {filteredData !== undefined ? (
          Object.entries(filteredData).map(([key, value]) => (
            <li>
              <span>{capitalizeWords(key)}</span> {value}
            </li>
          ))
        ) : (
          <li>null</li>
        )}
      </ul>
    </div>
  );
};

export default DetailInfoElement;
